import {
  getPlanCourseList,
  getSubjectList,
  getUserList,
  getPlanList,
  addPlan,
  updatePlan,
  deletePlan,
  addCourse,
  updateNotice,
  getNoticeStatus
} from '@/api/plan';

const plan = {
  namespaced: true,
  state: {
    planIsLoading: false,
    addPlanFlag: false,
    attendancePlanList: [],
    planMainContentTitle: [
      { id: 1, name: '课节' },
      { id: 2, name: '星期一' },
      { id: 3, name: '星期二' },
      { id: 4, name: '星期三' },
      { id: 5, name: '星期四' },
      { id: 6, name: '星期五' },
      { id: 7, name: '星期六' },
      { id: 8, name: '星期日' }
    ],
    planMainContentList: [],
    planNameTip: '',
    subjectList: [],
    teacherList: [],
    editClassList: [] // 编辑作息时，备份使用范围
  },
  mutations: {
    SET_EDIT_CLASS_LIST: (state, editClassList) => {
      state.editClassList = editClassList;
    },
    SET_PLAN_IS_LOADING: (state, planIsLoading) => {
      state.planIsLoading = planIsLoading;
    },
    SET_ADD_PLAN_FLAG: (state, addPlanFlag) => {
      state.addPlanFlag = addPlanFlag;
    },
    SET_PLAN_MAIN_CONTENT_LIST: (state, planMainContentList) => {
      state.planMainContentList = planMainContentList;
      let length = 0;// 课节长度
      if (planMainContentList&&planMainContentList.length>0) {
        if (planMainContentList[0].planList&&planMainContentList[0].planList.length>0) {
          length = planMainContentList[0].planList.length;
          state.planNameTip = planMainContentList[0].planList[0].planName;
        } else {
          state.planNameTip = '无'
        }
        // 周六周日补全
        planMainContentList.forEach(element => {
          if (!element.planList || element.planList.length == 0) {
            let newArr = [];
            for(let i=0;i<length;i++) {
              newArr.push({
                id: new Date().getTime()
              })
            }
            console.log(newArr)
            element.planList = newArr;
          } else if (element.planList.length != length) {
            // 不能直接push，前台按顺序渲染，比如只有第一节，第三节，，，根据sectionId判断
            // sectionId课节，第几节
            let newArr = [];
            for(let i=0;i<length;i++) {
              let ishave = false
              element.planList.forEach((list,index) => {
                if (list['sectionId'] == i+1) {
                  ishave = true;
                  newArr.push(list)
                }
              })
              if (!ishave) {
                newArr.push({
                  id: new Date().getTime()
                })
              }
            }
            element.planList = newArr;
          }
        });
      } else {
        state.planNameTip = '';
      }
      console.log(planMainContentList, 'content')
    },
    SET_ATTENDANCE_PLAN_LIST: (state, attendancePlanList) => {
      state.attendancePlanList = attendancePlanList;
    },
    SET_SUBJECT_LIST: (state, subjectList) => {
      state.subjectList = subjectList;
    },
    SET_TEACHER_LIST: (state, teacherList) => {
      state.teacherList = teacherList;
    }
  },
  actions: {
    async changeAddPlan({ commit }, addPlan) {
      commit('SET_ADD_PLAN_FLAG', addPlan);
    },
    async changePlanIsLoading({ commit }, planIsLoading) {
      commit('SET_PLAN_IS_LOADING', planIsLoading);
    },
    getSubjectList({ commit }) {
      return new Promise((resolve, reject) => {
        getSubjectList().then(res => {
          const subjectList = [];
          for (let i = 0; i < res.length; i++) {
            const element = res[i];
            subjectList.push({
              id: element.tech_id,
              value: `${element.tech_id}-${element.tech_name}`,
              name: element.tech_name
            });
          }
          commit('SET_SUBJECT_LIST', subjectList);
          resolve();
        });
      });
    },
    getTacherList({ commit }, requestParams) {
      return new Promise((resolve, reject) => {
        getUserList(requestParams).then(res => {
          const teacherList = [];
          for (let i = 0; i < res.length; i++) {
            const element = res[i];
            if (element.thirdPartyId) {
              teacherList.push({
                id: element.thirdPartyId,
                value: `${element.thirdPartyId}-${element.mobile}-${element.realName}`,
                realName: element.realName
              });
            }
          }
          commit('SET_TEACHER_LIST', teacherList);
          resolve();
        });
      });
    },
    getData({ commit }, requestParams) {
      commit('SET_PLAN_IS_LOADING', true);
      this.dispatch('ai/plan/changePlanIsLoading', true);
      return new Promise((resolve, reject) => {
        getPlanCourseList(requestParams)
          .then(res => {
            if (res.length > 0) {
              commit('SET_PLAN_MAIN_CONTENT_LIST', res);
            } else {
              commit('SET_PLAN_MAIN_CONTENT_LIST', []);
            }
            this.dispatch('ai/plan/changePlanIsLoading', false);
            resolve();
          })
          .catch(err => {
            this.dispatch('ai/plan/changePlanIsLoading', false);
            reject(err);
          });
      });
    },
    getAttendPlanList({ commit }, requestParams) {
      this.dispatch('ai/plan/changePlanIsLoading', true);
      getPlanList(requestParams).then(res => {
        commit('SET_ATTENDANCE_PLAN_LIST', res);
        this.dispatch('ai/plan/changePlanIsLoading', false);
      })
      .catch(err => {
        this.dispatch('ai/plan/changePlanIsLoading', false);
        reject(err);
      });
    },
    addPlan(_, requestParams) {
      return new Promise((resolve, reject) => {
        addPlan(requestParams)
          .then(res => {
            console.log(res);
            if (res) {
              resolve(true);
            } else {
              resolve(false);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    updatePlan(_, requestParams) {
      return new Promise((resolve, reject) => {
        updatePlan(requestParams)
          .then(res => {
            console.log(res);
            if (res) {
              resolve(true);
            } else {
              resolve(false);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    deletePlan(_, requestParams) {
      return new Promise((resolve, reject) => {
        deletePlan(requestParams)
          .then(res => {
            console.log(res);
            if (res) {
              resolve(true);
            } else {
              resolve(false);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    updateNotice(_, requestParams) {
      return new Promise((resolve, reject) => {
        updateNotice(requestParams)
          .then(res => {
            console.log(res);
            if (res) {
              resolve(true);
            } else {
              resolve(false);
            }
          })
          .catch(err => {
            resolve(false);
            reject(err);
          });
      });
    },
    getNoticeStatus(_, requestParams) {
      return new Promise((resolve, reject) => {
        getNoticeStatus(requestParams)
          .then(res => {
            console.log(res);
            if (res) {
              resolve(res);
            } else {
              resolve(false);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    addCourse(_, requestParams) {
      return new Promise((resolve, reject) => {
        addCourse(requestParams)
          .then(res => {
            console.log(res);
            if (res) {
              resolve(true);
            } else {
              resolve(false);
            }
          })
          .catch(err => {
            resolve(false);
            reject(err);
          });
      });
    }
  }
};

export default plan;
